<template>
  <div>
    <b-card
      class="card-transaction"
      no-body
    >
      <b-card-header>
        <b-card-title>
          <span>Edit Wallet</span>
        </b-card-title>
        <feather-icon
          style="cursor:pointer"
          size="20"
          icon="XCircleIcon"
          @click="$emit('hide-edit-section')"
        />
      </b-card-header>

      <b-card-body>

        <b-form-checkbox
          v-model="editWalletData.applyZoneCommission"
          name="checkbox-input"
          class="mb-2"
        >
          Apply Zone Commission
        </b-form-checkbox>

        <b-form-group label="Commission Amount">
          <validation-provider
            #default="ctx"
            name="Commission Amount"
            rules="between:0,1"
          >
            <b-input-group>
              <b-form-input
                v-model="editWalletData.overrideCommissionAmount"
                :disabled="editWalletData.applyZoneCommission"
                placeholder="Commission Amount"
                :state="ctx.errors.length > 0 ? false:null"
                type="number"
              />
              <b-input-group-append is-text>
                <span>JOD</span>
              </b-input-group-append>
              <small class="text-danger">{{ ctx.errors[0] }}</small>
            </b-input-group>
          </validation-provider>

        </b-form-group>
        <b-form-group label="Block Threshold">
          <b-input-group>
            <b-form-input
              v-model="editWalletData.blockThreshold"
              placeholder="Block Threshold"
              type="number"
            />
            <b-input-group-append is-text>
              <span>JOD</span>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>

        <b-button
          variant="primary"
          :disabled="submitBtnLoading"
          @click="editDriverWallet"
        >
          <b-spinner
            v-if="submitBtnLoading"
            small
          />
          <span v-else>Submit</span>
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BFormGroup, BFormInput, BButton, BFormCheckbox,
  BInputGroup, BInputGroupAppend, BSpinner,
} from 'bootstrap-vue'

import { ValidationProvider } from 'vee-validate'
import { between } from '@validations'

import { reactive, ref } from '@vue/composition-api'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import store from '@/store'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    BSpinner,
  },
  props: {
    driverWallet: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, ctx) {
    const toast = useToast()

    const editWalletData = reactive({
      applyZoneCommission: props.driverWallet.applyZoneCommission,
      overrideCommissionAmount: props.driverWallet.overrideCommissionAmount,
      blockThreshold: props.driverWallet.blockThreshold,
    })

    const submitBtnLoading = ref(false)
    const editDriverWallet = async () => {
      try {
        if (editWalletData.overrideCommissionAmount > 1 || editWalletData.overrideCommissionAmount < 0) return
        submitBtnLoading.value = true
        await store.dispatch('driverView/updateDriverWallet', {
          walletId: props.driverWallet.id,
          walletInfo: editWalletData,
        })
        toast({
          component: ToastificationContent,
          props: {
            title: 'Driver wallet edited successfully',
            icon: 'CoffeeIcon',
            variant: 'success',
          },
        })
        ctx.emit('refetch-driver-wallet')
      } catch (err) {
        console.log(err)
      } finally {
        submitBtnLoading.value = false
      }
    }
    return {
      editWalletData,
      editDriverWallet,
      submitBtnLoading,
      between,
    }
  },
}
</script>
